import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
interface AccordionItemProps {
  title: string | React.ReactNode;
  children: React.ReactNode;
  isOpen?: boolean;
  onClick?: () => void;
}
export function AccordionItem({
  title,
  children,
  isOpen = false,
  onClick
}: AccordionItemProps) {
  return <div className="border-b border-slate-200 last:border-0" data-id="element-320">
      <button className="flex w-full items-center justify-between py-4 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-teal-500 rounded-lg px-2" onClick={onClick} aria-expanded={isOpen} data-id="element-321">
        <span className="font-semibold text-slate-900" data-id="element-322">{title}</span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.2
      }} className="ml-4 flex-shrink-0 text-slate-400" data-id="element-323">
          <ChevronDown className="h-5 w-5" data-id="element-324" />
        </motion.div>
      </button>
      <AnimatePresence initial={false} data-id="element-325">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-326">
            <div className="pb-4 px-2 text-slate-600" data-id="element-327">{children}</div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
interface AccordionProps {
  items: {
    title: string | React.ReactNode;
    content: React.ReactNode;
  }[];
  className?: string;
}
export function Accordion({
  items,
  className = ''
}: AccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <div className={`rounded-2xl border border-slate-200 bg-white p-2 shadow-sm ${className}`} data-id="element-328">
      {items.map((item, index) => <AccordionItem key={index} title={item.title} isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-329">
          {item.content}
        </AccordionItem>)}
    </div>;
}